import * as echarts from 'echarts'

// var myChart = null
const setCharts = (chartDom, title, Xdata, Ydata, rotate='45', top='28%', left='4%') => {
  echarts.dispose(chartDom)
  var myChart = echarts.init(chartDom)
  // if (myChart === null) { // 只有第一次才实例化
  //   myChart = echarts.init(chartDom)
  // }
  var option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    title: {
      top: '3%',
      left: '4%',
      text: title,
      subtext: ''
    },
    grid: {
      top: top,
      left: left,
      right: '4%'
    },
    // toolbox: {
    //   show: true,
    //   feature: {
    //     mark: { show: true },
    //     dataView: { show: true, readOnly: false },
    //     magicType: { show: true, type: ['line', 'bar'] },
    //     restore: { show: true },
    //     saveAsImage: { show: true }
    //   }
    // },
    xAxis: {
      axisLabel: {
        interval: 0,
        rotate: rotate,
        position: 'center'
        // margin: -280, //刻度标签与轴线之间的距离
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      type: 'category',
      data: Xdata
    },
    yAxis: {
      type: 'value',
      // name: '单位: %',
      axisLabel: {
        show: true,
        interval: 'auto'
        // formatter: function (value) {
        //   return (value*100) + '%';
        // }
      }
    },
    series: [
      {
        type: 'bar',
        data: Ydata,
        label: {
          show: true,
          position: 'top',
          rotate: rotate,
          offset: [20, 0]
          // formatter: function (value) {
          //     return (value.value*100).toFixed(1) + '%';
          // }
        },
        itemStyle: {
          normal: {
            color:function(params){
              var index_color = params.value;
              if (index_color > 0){
                return '#f72c5b'
              } else {
                return '#1BCBB0'
              }
            }
          }
        }
      }
    ]
  }
  option && myChart.setOption(option)
  // var baseImage = myChart.getDataURL("png");
  // console.log(baseImage)
  return myChart
}

export { setCharts }
